import React from "react";
import {
  FeatherCheckCircle,
  FeatherCircleDot,
  FeatherRefreshCw,
  FeatherXCircle,
} from "@subframe/core";
import { Loader } from "../../../../ui/components/Loader";
import {
  getPostedStatusLabel,
  getStoredAccountingBackend,
} from "../../../../config/accounting";
import { DebitNoteCountsEntity, DebitNoteListStatus } from "../../domain";

interface DebitNoteStatsCardsProps {
  counts: DebitNoteCountsEntity | null;
  loading: boolean;
  onSelectStatus: (status: DebitNoteListStatus) => void;
}

export const DebitNoteStatsCards: React.FC<DebitNoteStatsCardsProps> = ({
  counts,
  loading,
  onSelectStatus,
}) => {
  const cards = [
    {
      label: "Pending",
      value: counts?.pendingCount ?? 0,
      status: "pending" as const,
      icon: <FeatherCircleDot className="text-body font-body text-neutral-500" />,
    },
    {
      label: "Under Review",
      value: counts?.underReviewCount ?? 0,
      status: "under_review" as const,
      icon: <FeatherRefreshCw className="text-body font-body text-warning-600" />,
    },
    {
      label: getPostedStatusLabel(getStoredAccountingBackend()),
      value: counts?.postedCount ?? 0,
      status: "posted" as const,
      icon: <FeatherCheckCircle className="text-body font-body text-success-600" />,
    },
    {
      label: "Rejected",
      value: counts?.rejectedCount ?? 0,
      status: "rejected" as const,
      icon: <FeatherXCircle className="text-body font-body text-error-500" />,
    },
  ];

  return (
    <div className="w-full items-start gap-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <button
          key={card.status}
          type="button"
          className="flex flex-col items-start gap-3 rounded-md border border-solid border-neutral-border px-4 py-4 text-left hover:bg-neutral-50"
          onClick={() => onSelectStatus(card.status)}
        >
          <div className="flex items-center gap-2">
            {card.icon}
            <span className="text-body font-body text-subtext-color">
              {card.label}
            </span>
          </div>
          <span className="text-heading-1 font-heading-1 text-default-font">
            {loading ? <Loader size="small" /> : card.value}
          </span>
        </button>
      ))}
    </div>
  );
};
